<script>
import { Base as BaseApi } from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBase';

export default {
  props: {
    method: { type: String, required: true },
    url: { type: String, required: true },
    payload: { type: Object, default: () => ({}) },
  },

  data: () => ({
    result: undefined,
    busy: false,
    error: undefined,
  }),

  methods: {
    async executeAction() {
      this.error = undefined;
      this.busy = true;
      try {
        let base = new BaseApi();
        let api = base.api();

        let result = await api.request({ method: this.method, url: this.url, data: this.payload });
        result = await base.handleResponse(result);

        this.$emit('executed', result);
        this.result = result;
      } catch (err) {
        this.error = String(err);
      } finally {
        this.busy = false;
      }
    }
  },
}
</script>

<template>
  <button
    type="button"
    v-bind="$attrs"
    v-on="$listeners"
    @click.stop="executeAction"
    class="position-relative"
    :disabled="busy">

    <slot :busy="busy" :error="error" :result="result"></slot>

    <b-alert v-if="error" variant="danger" show>{{error}}</b-alert>

    <div v-if="busy" class="position-absolute" style="bottom:3px; left:3px; right:3px;">
      <b-progress variant="secondary" animated style="height:5px;">
        <b-progress-bar :value="100">
        </b-progress-bar>
      </b-progress>
    </div>

  </button>
</template>



// WEBPACK FOOTER //
// src/AxiosApiButton.vue